import Page from "@/lib/components/Page";
import {StyleSheet, Text} from "react-native";
import Nav from "@/lib/components/Nav";
import ActionButton from "@/lib/components/ActionButton";
import PrimaryText from "@/lib/components/PrimaryText";
import {Color} from "@/lib/styles";
import Editable from "@/lib/components/Editable";
import {useChat} from "@/lib/components/ChatProvider";
import SpinnerPage from "@/lib/components/SpinnerPage";
import Radio from "@/lib/components/Radio";
import Header from "@/lib/components/Header";
import {useState} from "react";

export default function Edit() {
    const {currentChat} = useChat();

    const [pinThread, setPinThread] = useState(false);
    const [lockThread, setLockThread] = useState(false);

    if (!currentChat) {
        return <SpinnerPage/>
    }

    return (
        <Page>
            <Editable color={Color.PrimaryText} onPress={() => {
            }}>
                <Text style={styles.editableKey}>Tittel</Text>
                <PrimaryText>{currentChat.chat.name}</PrimaryText>
            </Editable>
            <Radio
                title={"Alltid på topp"}
                checkbox={true}
                selected={pinThread}
                description={"Fest meldingstråd øverst på eventet eller samfunnet."}
                onPress={() => setPinThread(!pinThread)}
            />
            <Header title={"Hvem kan svare"}/>
            <Radio
                title={"Deltakere"}
                checkbox={false}
                selected={!lockThread}
                description={"Deltakere og følgere kan svare."}
                onPress={() => setLockThread(false)}
            />
            <Radio
                title={"Arrangør"}
                checkbox={false}
                selected={lockThread}
                description={"Kun arrangører og moderatorer kan svare."}
                onPress={() => setLockThread(true)}
            />
            <Nav>
                <ActionButton
                    onPress={() => {
                    }}
                    color={Color.PrimaryText}
                    title={"Lagre"}
                />
                <ActionButton
                    onPress={() => {
                    }}
                    color={Color.Red}
                    title={"Slett meldingstråd"}
                />
            </Nav>
        </Page>
    )
}

export const styles = StyleSheet.create({
    container: {
        borderStyle: "dashed",
        borderRadius: 8,
        borderWidth: 1,
        paddingVertical: 12,
        paddingHorizontal: 12,
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        columnGap: 16,
        rowGap: 4,
        width: "100%",
        outlineStyle: "solid",
    },
    editableKey: {
        fontSize: 16,
        fontWeight: 600,
        color: Color.PrimaryText,
    }
})